import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>Aero Industrial Hub</h3>
            <p>Your partner in industrial property management</p>
          </div>
          
          <div className="footer-links">
            <div className="link-section">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/properties">Properties</Link></li>
                <li><Link to="/dashboard">Dashboard</Link></li>
              </ul>
            </div>
            
            <div className="link-section">
              <h4>Contact</h4>
              <ul>
                <li>Email: aeroindustrialhub@gmail.com</li>
                <li>Phone: +60 16-282 0967</li>
                {/* <li>Phone: +60 12-239 8446</li> */}
                <li>Kajang, Malaysia</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} AeroIndustrialHub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
